import { RefundTravellerFragment } from '@websky/graphql';
import { getTravellerContactInfoValues } from '@shared/lib/passengers';
import { TravellerValue } from '../../../../Checkout/types';
import { RefundPassenger } from '../model/passengers/types';
import { RefundPassengersState } from '../model/types';
import { buildRefundPassengers } from './buildRefundPassengers';

const mapTravellerToValue = (traveller: RefundTravellerFragment): TravellerValue => ({
	id: traveller.id,
	type: traveller.type,
	supplierTravellerType: traveller.supplierTravellerType,
	linkedTraveller: traveller.linkedTraveller
		? {
				id: traveller.linkedTraveller.id,
				type: traveller.linkedTraveller.type,
				values: getTravellerContactInfoValues(traveller.linkedTraveller.values)
		  }
		: undefined,
	values: getTravellerContactInfoValues(traveller.values)
});

/** Приводит `RefundTravellerFragment` к `TravellerValue` (как `getTravellersValues` для заказа). */
export const mapRefundTravellersToValues = (
	travellers: Array<RefundTravellerFragment | null | undefined>
): TravellerValue[] =>
	travellers.filter((traveller): traveller is RefundTravellerFragment => traveller !== null).map(mapTravellerToValue);

/**
 * Строит refund-модель пассажиров для страницы заявки (без Redux state).
 *
 * Все пассажиры считаются выбранными.
 * Дальше переиспользуется `buildRefundPassengers`.
 *
 * @param travellers - пассажиры из `getLastRefund().travellers`.
 */
export const buildRequestRefundPassengers = (
	travellers: Array<RefundTravellerFragment | null | undefined>
): RefundPassenger[] => {
	const travellerValues = mapRefundTravellersToValues(travellers);
	const selection = travellerValues.reduce<RefundPassengersState>((acc, traveller) => {
		acc[traveller.id] = true;

		return acc;
	}, {});

	return buildRefundPassengers(travellerValues, selection);
};
